/* Luxiage AI pranesimas: maza "AI" zyma, paspaudus salia jos atsidengia pilnas sakinys. Produkto puslapyje po galerija, pagrindiniame puslapyje autoriaus teisiu eiluteje */
(function () {
  'use strict';

  var TEXT_LT = 'Kai kuriuose svetainės vaizduose, scenai ar papuošalų dėvėjimui pavaizduoti, naudojamas AI.';
  var TEXT_EN = "In some of the website's images, AI is used to depict the scene or show the jewelry being worn.";
  var lang = (document.documentElement.lang || '').toLowerCase();
  var TEXT = lang.indexOf('lt') === 0 ? TEXT_LT : TEXT_EN;

  /* Po kiek ms nuo paspaudimo sakinys vel uzsidaro iki "AI" (atsidengimas trunka 1,8 s, uzsidarymas 1,0 s) */
  var AUTO_CLOSE_MS = 5800;

  /* Pagrindinio puslapio vieta: 'below' = atskira eilute po autoriaus teisiu juosta, 'inline' = autoriaus teisiu eiluteje */
  var HOME_PLACEMENT = 'inline';

  function makeButton(text) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ai-note-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', text);

    var shortEl = document.createElement('span');
    shortEl.className = 'ai-note-short';
    shortEl.textContent = 'AI';

    var longEl = document.createElement('span');
    longEl.className = 'ai-note-long';
    longEl.textContent = text;

    btn.appendChild(shortEl);
    btn.appendChild(longEl);

    var timer = null;
    function setOpen(open) {
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (timer) { clearTimeout(timer); timer = null; }
      if (open) {
        timer = setTimeout(function () { setOpen(false); }, AUTO_CLOSE_MS);
      }
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(!btn.classList.contains('is-open'));
    });

    return btn;
  }

  function makeNote(tag, cls, text) {
    var el = document.createElement(tag);
    el.className = cls;
    el.appendChild(makeButton(text));
    return el;
  }

  function run() {
    var body = document.body;
    if (!body) return;

    if (body.classList.contains('template-product')) {
      var galleries = document.querySelectorAll('product-images');
      for (var i = 0; i < galleries.length; i++) {
        if (!galleries[i].querySelector(':scope > .ai-gallery-note')) {
          galleries[i].appendChild(makeNote('p', 'ai-gallery-note', TEXT));
        }
      }
    }

    if (body.classList.contains('template-index') && !document.querySelector('.ai-home-note')) {
      var bar = document.querySelector('.supporting-menu');
      if (!bar) return;
      if (HOME_PLACEMENT === 'inline') {
        var list = bar.querySelector('.supporting-menu__copyright');
        if (list) {
          var li = makeNote('li', 'ai-home-note ai-home-note--inline', TEXT);
          var powered = list.querySelector('[data-powered-link]');
          list.insertBefore(li, powered ? powered.nextSibling : null);
        }
      } else {
        bar.appendChild(makeNote('p', 'ai-home-note ai-home-note--below', TEXT));
      }
    }

    /* Tik Shopify perziuros rezime: juosta apacioje uzdengia puslapio gala, tad pridedam laikina tarpa (tikrame puslapyje jo nebus) */
    if (document.getElementById('PBarNextFrame')) {
      var homeNote = document.querySelector('.ai-home-note--below');
      if (homeNote) homeNote.style.paddingBottom = '90px';
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
